import React from "react";
import { Select, Input, Button } from "antd";
import CheckBox from "../../../components/comment/checkboxwrap/checkbox";

const { Option } = Select;

const handleChange = (value) => {
  console.log(`selected ${value}`);
};

const addnewdetal = () => {
  return (
    <div className="add-new-detail">
    <div className="add-new-detail-wrap">
      <div className="row">
        <div className="col-lg-12">
          <div className="rightbar-title">Add new net banking details</div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6">
          <div className="bank-detail-left-wrap bank-detail">
            <div className="      col-4">
              <div className="select-bank">Select bank*</div>
            </div>
            <div className="      col-8">
              {" "}
              <div className="select-bank-input">
                <Select
                  defaultValue="Select your bank"
                 
                  onChange={handleChange}
                >
                  <Option value="jack">State Bank of India</Option>
                  <Option value="lucy">Canara BANK</Option>
                  <Option value="Yiminghe">Bank of Mahrashtra</Option>
                </Select>
              </div>
            </div>
            {/* <div className="select-bank">Select bank*</div>
            <div className="select-bank-input">
              <Select
                defaultValue="Select your bank"
                style={{
                  width: 220,
                }}
                onChange={handleChange}
              >
                <Option value="jack">State Bank of India</Option>
                <Option value="lucy">Canara BANK</Option>
                <Option value="Yiminghe">Bank of Mahrashtra</Option>
              </Select>
            </div> */}
          </div>
        </div>

        <div className="col-lg-6">
          <div className="bank-detail-left-wrap bank-detail">
            <div className=" col-4">
              {" "}
              <div className="select-bank">Branch*</div>
            </div>
            <div className=" col-8">
              {" "}
              <div className="select-bank-input">
                <Select
                  defaultValue="Select your branch"
                 
                  onChange={handleChange}
                >
                  <Option value="jack">Mahrashtra</Option>
                  <Option value="lucy">jammu</Option>
                  <Option value="Yiminghe">Piplod</Option>
                </Select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6">
          <div className="bank-detail-left-wrap bank-detail">
            <div className="   col-4">
              {" "}
              <div className="select-bank">Account Number*</div>
            </div>
            <div className="  col-8">
              {" "}
              <div className="select-bank-input">
                <Input type="password" placeholder="XXXX XXXX XXXX" />
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="bank-detail-left-wrap bank-detail">
            <div className="  col-4">
              <div className="select-bank">Re-type Account Number*</div>
            </div>
            <div className="  col-8">
              {" "}
              <div className="select-bank-input">
                <Input type="password" placeholder="XXXX XXXX XXXX" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-6">
          <div className="bank-detail-left-wrap bank-detail">
            <div className="  col-4">
              {" "}
              <div className="select-bank">IFSC Code*</div>
            </div>
            <div className="  col-8">
              {" "}
              <div className="select-bank-input">
                <Input type="text" placeholder="Enter IFSC Code" />
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="bank-detail-left-wrap bank-detail">
            <div className="  col-4">
              {" "}
              <div className="select-bank">Account Holder Name*</div>
            </div>
            <div className="  col-8">
              {" "}
              <div className="select-bank-input">
                <Input type="text" placeholder="Enter your name" />
              </div>
            </div>
          </div>
        </div>

        

      </div>

      </div>

            <div className="row">
              <div className="col-lg-12">
              <div className="car-detail-wrap">
              <CheckBox />
            </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="new-detail-process-btn">
                <Button type="primary">Process</Button>
                </div>
              </div>
            </div>
           


    </div>
  );
};

export default addnewdetal;
